import { useMutation } from "@tanstack/react-query";

import { interludeClient } from "@/interlude";

export function useAuthorizeWithGoogle() {
  return useMutation({
    mutationFn: () => interludeClient.googleAds.getOAuthAuthorizationUrl(),
    onSuccess(data) {
      window.location.assign(data.authorizationUrl);
    },
  });
}
